<template>
  <div class="tab-item-cls">
    <div class="title">
      <!-- <span class="tab-img transcation-tag"></span>
      <span class="item-title">M&A Transactions</span> -->
      <p class="pde" :title="detail">{{detail}}</p>
    </div>
    <div class="row-top" :style="{'height':chartHeight +'px'}">
      <p
        v-for="(item,index) of lists"
        :key="index"
        :title="item.nodeDesc"
        @click="toItem(item)"
      >{{item.name}}</p>
    </div>
  </div>
</template>

<script>
import { getTranscationData } from "common/js/http/v2Api";
import { mapMutations } from "vuex";
export default {
  props: {
    chartHeight: {
      type: Number
    }
  },

  components: {},

  data() {
    return {
      lists: [],
      detail:`It provides the latest M&A transactions worldwide and supports the search by country, deal status and type. You can find information of a M&A deal, such as acquisition time, acquisition project name, acquirer financial information, etc. `
    };
  },

  created() {
    console.log("transcation create");
  },

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      const { result } = await getTranscationData();
      this.lists = result;
    },

    toItem(item) {
      console.log(item);
      if (item.nodeDesc) {
        this.$router.push({
          path: "/data/SearchModule/Transaction",
          query: {
            id: item.nodeDesc
          }
        });
        this.changeIndexShow(false);
      }
    },
    ...mapMutations(["changeIndexShow"])
  }
};
</script>

<style scoped>
.company-title {
  font-size: 12px;
  color: #000000;
  margin-top: 30px;
  font-weight: 600;
}
.row-top {
  margin-top: 49px;
  border: 1px solid #f3f4f5;
  overflow: auto;
}
.row-top p {
  cursor: pointer;
  line-height: 41px;
  border-bottom: 1px solid #f3f4f5;
  padding: 0px 20px;
  color: #615757;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.row-top p:nth-child(odd) {
  background: #f8f9f9;
}
</style>